import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import ModulesDetail from "../../components/ModulesDetail/ModulesDetail";
export default class ModulesDetailPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <ModulesDetail />
            </div>
        )
    }
}